$(document).ready(function(){
    /* GLOBALS */
    var autoSlide = true;

    /*
    // Bottom to top smooth scroll
    // Should be able to utilize this for sticky nav in page scrolling as well
    // And could even adapt this to function with horizontal scrolling
    */
    var smoothScroll = function() {
        $('body').on('click', 'a[href*="#"]', function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
                && 
                location.hostname == this.hostname
            ) {
                this.focus();
                var target = $(this.hash);

                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 60
                    }, 1000, function() {});
                }
            }
        });
    }


    var setupValues = function() {
        animateHero();
        animatePage(); 
    }


    /*  Animation/Scrolling
    -------------------------------------------------- */
    var animateHero = function(){
        $heroGrid1 = $('#hero-grid-1');
        $heroGrid2 = $('#hero-grid-2');
        $heroGrid3 = $('#hero-grid-3');
        $heroGrid4 = $('#hero-grid-4');

        var heroGrid1 = new TimelineMax ()
            .add([
                TweenMax.fromTo($heroGrid1, 1, {y:70, opacity: 0}, {y:0, opacity:1}),
                TweenMax.fromTo($heroGrid2, 1, {y:70, opacity: 0}, {y:0, opacity:1, delay: 0.5}),
                TweenMax.fromTo($heroGrid3, 1, {y:70, opacity: 0}, {y:0, opacity:1, delay: 0.25}),
                TweenMax.fromTo($heroGrid4, 1, {y:70, opacity: 0}, {y:0, opacity:1, delay: 0.75})
            ]);
    }

    var animateImgRight = function() {
        $img = $('#homepage__img-right-image');

        var imgGrid = new TimelineMax ()
            .add([
                TweenMax.fromTo($img, 1, {x:150}, {x:0})
            ]);
    }

    var animateImgGrid= function() {
        $imgGrid1 = $('#text-img-grid-1');
        $imgGrid2 = $('#text-img-grid-2');
        $imgGrid3 = $('#text-img-grid-3');

        var imgGrid = new TimelineMax ()
            .add([
                TweenMax.fromTo($imgGrid1, 1, {y:70, opacity: 0}, {y:0, opacity:1}),
                TweenMax.fromTo($imgGrid2, 1, {y:70, opacity: 0}, {y:0, opacity:1, delay: 0.25 }),
                TweenMax.fromTo($imgGrid3, 1, {y:70, opacity: 0}, {y:0, opacity:1, delay: 0.5 })
            ]);
    }

    var animatePage = function(){
        controller = new ScrollMagic.Controller();

        var imgGridFadeIn = new ScrollMagic.Scene({triggerElement: '#homepage__img-right',duration: 300, offset: -200, reverse: false})
            .on("enter", function(event) {
                animateImgRight();
            })
            .addTo(controller);

        var imgGridFadeIn = new ScrollMagic.Scene({triggerElement: '#homepage__text-img-panel',duration: 300, offset: 100, reverse: false})
            .on("enter", function(event) {
                animateImgGrid();
            })
            .addTo(controller);   
    }
   

    var init = function () { 
        smoothScroll();
        setupValues();
    }



    init();
});
